function config(){
	return {
		webname:'文一科技考试系统',
		url:'http://ys.wuxie.stu.fywy0558.com',
		frontUrl:'http://ys.wuxie.fywy0558.com/',
		WebSocket:'http://127.0.0.1:2130', 
	}
}

function doMain(){return this.config().url+'/admin';}
function login(){return this.doMain() + '/admins/login';}
function register(){return this.doMain() + '/admins/register';}
function edit_oneself(){return this.doMain() + '/admins/edit_oneself';}
function upload(){return this.doMain() + '/upload/add';}
export default{
	doMain,
	login,
	register,
	edit_oneself,
	upload,
	config, 
}